import { codGrey } from './Colors';
import styled from 'styled-components';
import {Heading2} from './Font';

export const SectionTitle = styled(Heading2)`
  color: ${codGrey};
`;
